/* eslint-disable arrow-body-style */
import http from './utils';
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';

export function getRealtimeSteamingTable(payload: any) {
  return http({
    url: `${prefix}/real_time_streaming/live_list`,
    method: 'post',
    ...payload,
  }) as Promise<overviewOriginType>;
}

export function getRealtimeSteamingDetail(payload: any) {
  return http({
    url: `${prefix}/real_time_streaming/live_details`,
    method: 'post',
    ...payload,
  }) as Promise<overviewOriginType>;
}

export function getRealtimeSteamingAiDetail(payload: any) {
  return http({
    url: `${prefix}/real_time_streaming/get_specially_summary`,
    method: 'post',
    ...payload,
  }) as Promise<overviewOriginType>;
}

export function getRealtimeSteamingTrend(payload: any) {
  return http({
    url: `${prefix}/real_time_streaming/live_timeline`,
    method: 'post',
    ...payload,
  }) as Promise<overviewOriginType>;
}

export function getRealtimeSteamingSummaryTopicList(payload: any) {
  return http({
    url: `${prefix}/real_time_streaming/summary_topic_list`,
    method: 'post',
    ...payload,
  }) as Promise<overviewOriginType>;
}

export function getRealtimeSteamingKeyMessageTopicList(payload: any) {
  return http({
    url: `${prefix}/real_time_streaming/key_message_topic_list`,
    method: 'post',
    ...payload,
  }) as Promise<overviewOriginType>;
}

export const aigcGetSteamingSummary: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/real_time_streaming/get_date_summary`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};

export const aigcCreateStreamingSummary: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/real_time_streaming/create_date_summary`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};

export function getStreamingDirectoryInfo(payload: any) {
  return http({
    url: `${prefix}/real_time_streaming/directory_info`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}
